export const categories = [
    'antiderrapante',
    'confeccionada',
    'esportiva',
    'original'
]